import React from 'react'


export default function Badge({text, color, block, className}) {
  return (
    <div className={`bg-badge${!!block ? '-block':''}${!!color ? `-${color}`:''} badge-cs${!!color && `-${color}`} ${className}` } >{text}</div>
  )
}
